import { Link } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

/**
 * Accessible breadcrumb strip. Pair it with the BreadcrumbList schema in <SEO breadcrumbs={…}/>.
 * items: [{ name: "Rent", path: "/rent" }, …]
 */
export default function Breadcrumbs({ items = [] }) {
  return (
    <nav aria-label="Breadcrumb" className="mb-6 text-sm" data-testid="breadcrumbs">
      <ol className="flex items-center flex-wrap gap-1 text-gray-500">
        <li className="flex items-center gap-1">
          <Link to="/" className="hover:text-[#7A1E2A] inline-flex items-center gap-1">
            <Home size={13} /> Home
          </Link>
        </li>
        {items.map((it, i) => {
          const last = i === items.length - 1;
          return (
            <li key={it.path} className="flex items-center gap-1">
              <ChevronRight size={13} className="text-gray-300" />
              {last ? (
                <span className="text-[#7A1E2A] font-semibold capitalize">{it.name}</span>
              ) : (
                <Link to={it.path} className="hover:text-[#7A1E2A] capitalize">{it.name}</Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
